// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__IVOeU","col":"styles_col__3URax"};